/**
 * Generic Activity Log Wrapper Component
 * Used across all modules (User, Role, Permission, Collector, etc.)
 */

import React from 'react';
import {ActivityLogList} from '../index';

interface ActivityLogProps {
    subjectType: 'user' | 'role' | 'permission' | 'collector' | 'participant' | 'board' | 'wallet' | 'wallet-transaction';
    subjectId: number;
    pageSize?: number;
    onError?: (error: any) => void;
}

const ActivityLog: React.FC<ActivityLogProps> = ({
    subjectType,
    subjectId,
    pageSize = 10,
    onError,
}) => {
    return (
        <ActivityLogList
            subjectType={subjectType}
            subjectId={subjectId}
            pageSize={pageSize}
            onError={onError}
        />
    );
};

export default ActivityLog;


